import {
	isBlank
}
from 'voUtils/tools.js';

import {
	favCount, onFavUpdate
}
from 'voUtils/FavStore.js';

export default {

	data: {
		name: undefined,
	},
	mounted: function () {
		onFavUpdate(() => {
			this.$forceUpdate();
		});

		$('.mainHeader').affix({
			offset: {
				top: 100
			}
		});
		$('.inner-page').affix({
			offset: {
				top: 100
			}
		});
		new Mmenu(document.querySelector('#mobilemenu'), {
			onClick: {
				close: true
			}
		});

		document.addEventListener('click', function (evnt) {
			var anchor = evnt.target.closest('a[href^="#/"]');
			if (anchor) {
				alert("Thank you for clicking, but that's a demo link.");
				evnt.preventDefault();
			}
		});


		$("#ss-menu").click(function () {

			$("#navbar").show();
			//$("#navbar").css("position", "fixed");




			//$(".sr-menu .fa-bars").hide();
			//$(".sr-menu .fa-times").show();

			//$("#close-icon").hide();


			$(".sticky-search").hide();
			//alert('hi');

		});

		$("#close-sr").click(function () {
			$(".sticky-search").show();
			$(".sticky-search").addClass("visible");
			//$("#close-icon").show();
			$(".sr-menu .fa-bars").show();

		});

		$("#close-icon").click(function () {
			$(".sticky-search").hide();
			$("#navbar").show();

			$(".sr-menu .fa-bars").show();
			$(".sr-menu .fa-times").hide();


		});



		$(document).ready(function () {
			$('.sticky-search').show();

			/*$('#ss-menu').click(function () {
				$('#navbar').show();
				//alert('hi');
				return false;
			});
			$('.sticky-search').show();*/
		});


	},

	methods: {

		navbarToggle: function () {

			var nav = this.$el;

			if (nav.className === "vo-nav-bar") {
				nav.className += " opened";
			} else {
				nav.className = "vo-nav-bar";
			}


		},
		favCount: favCount,
		goSearch: function () {
			if (isBlank(this.name)) {
				window.location.href = 's';
			} else {
				window.location.href = 's#?name=' + encodeURIComponent(this.name);
			}
		}
	}
};